import { render, staticRenderFns } from "./topbarSaveButton.vue?vue&type=template&id=059923a8&"
import script from "./topbarSaveButton.vue?vue&type=script&lang=js&"
export * from "./topbarSaveButton.vue?vue&type=script&lang=js&"
import style0 from "./topbarSaveButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports